const {Component} = require("react");
const PropTypes = require("prop-types");
const assign = require("object-assign");
const global = global || window;
const google = global.google;

class Map extends Component {

	static get propTypes() {
		return {
			latitude: PropTypes.number.isRequired,
			longitude: PropTypes.number.isRequired,
			title: PropTypes.string,
			options: PropTypes.object
		};
	}

	static get defaultProps() {
		return {
			title: "",
			options: {
				zoom: 15,
				disableDefaultUI: false,
				draggable: true,
				zoomControl: true,
				scrollwheel: true,
				disableDoubleClickZoom: true
			}
		};
	}

	componentDidMount() {
		if (google == undefined) {
			throw new Error("Map cannot be initialized because the google library is missing!");
		}

		this.map = new google.maps.Map(this.mapElement, assign({}, this.props.options, {
			center: new google.maps.LatLng(this.props.latitude, this.props.longitude)
		}));

		this.marker = new google.maps.Marker({
			position: new google.maps.LatLng(this.props.latitude, this.props.longitude),
			map: this.map,
			title: this.props.title
		});
	}

	render() {
		return (
			<div ref={el => this.mapElement = el} className="map"></div>
		);
	}

}

module.exports = Map;